<script>
import service from '@/request/base'
import moment from 'moment'
const notphoto = require('@/assets/noimage.jpg')
export default {
  name: 'PatientSymptomWindow',
  components: {},
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {},
  created: function () {
  },
  watch: {
  },
  methods: {
    handlerClickWindow () {
      this.$emit('click-window', this.data)
    },
    handlerAdopt (event) {
      event.stopPropagation()
      this.$emit('click-adopt', this.data)
    },
    handlerDelete (event) {
      event.stopPropagation()
      this.$emit('click-delete', this.data)
    }
  },
  filters: {
    imageFilter (value) {
      if (!value) {
        return notphoto
      }
      return service.url(value)
    },
    dateFilter (time) {
      if (!time) {
        return ''
      }
      return moment(time).format('YYYY-MM-DD')
    }
  }
}
</script>

<template>
  <div class="symptom-window">
    <div class="badge" :style="{background: data.hospitalized === 1 ? '#3b6577' : '#5ecca7'}">
      <span>{{data.tag || '未分类'}}</span>
    </div>
    <div class="info-content" @click="handlerClickWindow()">
      <div class="image">
        <div class="image-wrap"><img :src="data.thumbnail | imageFilter"></div>
      </div>
      <div class="pat-info">
        <span>{{ data.name }}</span>
        <span>{{ !!data.sex && data.sex % 2 === 0 ? '女' : '男' }}</span>
        <span>{{ data.age }}岁</span>
      </div>
      <div class="symptom-info">
        <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
          <div class="symptom-item clear">
            <span class="lable">部位</span>
            <span class="text">{{data.position || '未知部位'}}</span>
          </div>
          <div class="symptom-item clear">
            <span class="lable">主述</span>
            <span class="text">{{data.reflect || '无'}}</span>
          </div>
          <div class="symptom-item clear">
            <span class="lable">症状</span>
            <span class="text">{{data.remark || '无'}}</span>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="window-footer clear">
      <el-form inline class="demo-form-inline fl" size="mini">
        <el-form-item style="margin-bottom: 0;">
          {{data.updateTime | dateFilter}}
        </el-form-item>
      </el-form>
      <el-form inline class="demo-form-inline fr" size="mini">
        <el-form-item style="margin-bottom: 0;">
          <el-button type="text" @click="handlerAdopt($event)" v-if="!data.hospitalized">采纳</el-button>
          <span v-else>已采纳</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 0;">
          <el-button type="text" style="color: #FF4949;" @click="handlerDelete($event)">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.symptom-window {
  position: relative;
}
.image,
.info-content,
.window-footer {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.image {
  width: 100%;
  height: 178px;
  font-size: 0;
  background-color: #fff;
  padding: 2px;
}
.image-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.image img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: block;
  margin: auto;
  padding: auto;
}
.info-content {
  width: 100%;
  padding: 0 10px;
}
.info-content .pat-info {
  font-size: 14px;
  font-weight: bold;
  height: 40px;
  overflow: hidden;
}
.info-content .pat-info > span {
  margin-right: 5px;
}
.symptom-info {
  height: 90px;
  overflow: hidden;
}
.symptom-info .symptom-item {
  width: 100%;
  margin-bottom: 5px;
  line-height: 18px;
}
.symptom-item .lable {
  width: 60px;
  text-align: left;
  float: left;
  color: #909399;
  padding: 0 8px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.symptom-item .text {
  display: block;
}
.symptom-item span.text {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden;  /** 隐藏超出的内容 **/
}
.window-footer {
  border-top: 1px solid #EBEEF5;
  line-height: 16px;
  font-size: 14px;
  padding: 10px;
}
.window-footer .button {
  padding: 0;
}
.badge {
  position: absolute;
  top: 0;
  left: 0;
  padding: 5px;
  color: #fff;
  z-index: 999;
}
</style>
